/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jolly_Still_Worm_ApproveInputs */

const fr_jolly_still_worm_approve = /** @type {(inputs: Jolly_Still_Worm_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton PB a bien été enregistré`)
};

/**

* @param {Jolly_Still_Worm_ApproveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const jolly_still_worm_approve = /** @type {((inputs?: Jolly_Still_Worm_ApproveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jolly_Still_Worm_ApproveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_jolly_still_worm_approve(inputs)
});